import React, { useEffect, useState } from "react";
import "./AvailabilityQuickLook.css";
import { getJSON } from "../../misc/qf.js";
import AvailabilityDataHolder from "./AvailabilityDataHolder.jsx";

const AvailabilityQuickLook = (props) => {
  if (!props.currentMember) {
    return null;
  }
  const [showSpinner, setShowSpinner] = useState(true);
  const [availabilities, setAvailabilities] = useState({});
  const [nextOccurrence, setNextOccurrence] = useState(undefined);
  const [recurringAvailabilities, setRecurringAvailabilities] = useState(undefined);
  const [submitUrl, setSubmitUrl] = useState(undefined);
  const [targetOccurrence, setTargetOccurrence] = useState(undefined);
  useEffect(() => {
    getJSON(props.sourceUrl).then((data) => {
      setAvailabilities(data.availability_by_team_member_id);
      if (props.targetDate) {
        setTargetOccurrence(props.targetDate);
      } else {
        setTargetOccurrence(data.next_occurrence);
      }
      setNextOccurrence(data.next_occurrence);
      setRecurringAvailabilities(data.recurring_availability_by_team_member_id);
      setSubmitUrl(data.submit_url);
      setShowSpinner(false);
    });
  }, [props.sourceUrl]);
  if (showSpinner) {
    return (
      <section className="container text-center mb-3">
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading &hellip;
      </section>
    );
  }
  let nextOccurrenceAvailability = availabilities;
  if (recurringAvailabilities) {
    nextOccurrenceAvailability = recurringAvailabilities[targetOccurrence];
  }
  return (
    <div>
      <AvailabilityDataHolder
        availability={nextOccurrenceAvailability}
        childMembers={props.childMembers}
        currentMember={props.currentMember}
        isRecurring={!!recurringAvailabilities}
        nextOccurrence={nextOccurrence}
        targetOccurrence={targetOccurrence}
        submitUrl={submitUrl}
      />
    </div>
  );
};

export default AvailabilityQuickLook;
